// this is an autogenerated file from App/Account/Content/Settings/Content/Leads/Content/Content/Settings/Content/Location/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_Leads_Content_Content_Settings_Content_Location_Content{
  session_user_locations(order_by: { name: asc }) {
    id
    _id
    text: name
  }
}

`